var map = {
	"./Armorite.jpg": 31828,
	"./Common.jpg": 75791,
	"./Epic.jpg": 33899,
	"./Legendary.jpg": 49159,
	"./Rare.jpg": 28760,
	"./Uncommon.jpg": 81368,
	"./Unlimited.jpg": 53804
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64334;